import React from 'react';
import './InputDisclaimer.scss';

const InputDisclaimer = (props) => (
    <p {...props}>
        <small className="id-input-disclaimer">
            {props.children}
        </small>
    </p>
);

export default InputDisclaimer;
